.pce-rtl.pce-rtl {
	direction: rtl;
}

.pce-rtl.show-line-numbers {
	scroll-padding: var(--_sp) calc(var(--padding-left) + var(--_sp)) var(--_sp) var(--_sp);
}

.pce-rtl.pce-rtl::before,
.pce-rtl .pce-line::before {
	left: auto;
	right: 0;
	background: none;
}

.pce-rtl textarea,
.pce-rtl .word-matches,
.pce-rtl .pce-invisibles,
.pce-rtl .pce-matches,
.pce-rtl .selection-matches {
	padding: 0 var(--padding-left) 0 var(--_pse) !important;
}

.pce-rtl .guide-indents {
	left: auto !important;
	right: var(--padding-left);
	transform: scaleX(-1);
}

.pce-rtl .pce-copy::after {
	left: calc(100% + 0.5em);
	right: auto;
}

.pce-rtl.show-line-numbers .pce-line::before {
	padding: 0 0 0 var(--_ns);
	background: var(--pce-bg);
}

.pce-rtl.show-line-numbers .pce-line::after {
	left: 0;
	right: var(--padding-left);
}

.pce-rtl.pce-nowrap .pce-line::before {
	margin: 0 calc(-1 * var(--padding-left)) 0 0;
}

.pce-rtl .pce-line {
	padding: 0 var(--padding-left) 0 var(--_pse);
}

.pce-rtl .pce-fold {
	margin: 0 calc(2px - var(--_ns)) 0 0;
	right: calc(2px + var(--padding-left) - var(--_ns));
}

.pce-rtl .closed-fold > ::after {
	transform: translateY(-50%) rotate(90deg);
}

div.pce-rtl .active-bracket {
	display: inline;
}
